export default {
  path: '/dual-meet',
  component: resolve => require(['@/components/common/ViewTemplate'], resolve),
  children: [
    {
      path: '',
      redirect: 'schedule',
    },
    {
      path: 'schedule',
      component: resolve => require(['@/components/dual-meet/Schedule.vue'], resolve),
    },
    {
      path: 'recruit',
      component: resolve => require(['@/components/dual-meet/Recruit.vue'], resolve),
    },
    {
      path: 'preview-game',
      component: resolve => require(['@/components/dual-meet/PreviewGame'], resolve),
    },
    {
      path: 'game',
      component: resolve => require(['@/components/dual-meet/Game'], resolve),
    },
    {
      path: 'game-image-list',
      component: resolve => require(['@/components/dual-meet/GameImageList'], resolve),
    },
    {
      path: 'share',
      component: resolve => require(['@/components/dual-meet/Share'], resolve),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/modules/dual-meet/index.js